const ContractSearchDateType = {
  onContract: "指定日に契約が有効",
  start: "指定日に契約開始",
  end: "指定日に契約終了",
  startWithin: "指定日±7日間に契約開始",
  endWithin: "指定日±7日間に契約終了",
}

export type ContractSearchDateTypeKey = keyof typeof ContractSearchDateType;

export const ContractSearchDateTypeConverter = (key :ContractSearchDateTypeKey | null) => {
  switch (key) {
    case "onContract":
      return "0";
    case "start":
      return "1";
    case "end":
      return "2";
    case "startWithin":
      return "3";
    case "endWithin":
      return "4";
    default:
      return "";
  }
} 

export default ContractSearchDateType;